/* VDPS motion components.
 *
 * Two behaviours from the reference package that Horizon has no equivalent for
 * (SCOPE_AUDIT.md sections 3.1 and 3.2):
 *
 *   1. [data-vdps-autoplay]  play-once-on-scroll video, then stop. Horizon's
 *      native video block does autoplay and loop, but not play-once.
 *   2. [data-vdps-dwell]     the staged Dwell logo reveal.
 *
 * Both honour prefers-reduced-motion, which the handoff README requires, and
 * both disconnect their observer after firing so nothing keeps running.
 */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
   * Play-once-on-scroll video
   * ------------------------------------------------------------------- */
  function initAutoplayVideo(root) {
    var video = root.matches('video') ? root : root.querySelector('video');
    if (!video) return;

    // Autoplay is only permitted when muted and inline.
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.loop = root.dataset.vdpsLoop === 'true';

    if (reduceMotion) {
      // Show the poster frame and never move.
      video.pause();
      video.removeAttribute('autoplay');
      video.setAttribute('controls', '');
      return;
    }

    video.pause();
    try {
      video.currentTime = 0;
    } catch (e) {
      // Safari can throw before metadata loads; harmless.
    }

    var started = false;
    if (!('IntersectionObserver' in window)) {
      // No observer support: just play. Better than never playing.
      video.play().catch(function () {});
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || started) return;
          started = true;
          try {
            video.currentTime = 0;
          } catch (e) {
            /* ignore */
          }
          var p = video.play();
          if (p && p.catch) {
            // Autoplay rejection is normal on some devices. Give the user
            // controls rather than leaving a dead frame.
            p.catch(function () {
              video.setAttribute('controls', '');
            });
          }
          observer.disconnect();
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(video);
  }

  /* ---------------------------------------------------------------------
   * Dwell logo reveal
   * ------------------------------------------------------------------- */
  function initDwellReveal(root) {
    if (reduceMotion) {
      // Reduced motion is handled entirely in CSS: a media query shows the
      // finished composite and disables the animation. Nothing to do here.
      return;
    }

    if (!('IntersectionObserver' in window)) {
      root.classList.add('vr-is-revealed');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          root.classList.add('vr-is-revealed');
          observer.disconnect();
        });
      },
      { threshold: 0.42 }
    );

    observer.observe(root);
  }

  function init() {
    document.querySelectorAll('[data-vdps-autoplay]').forEach(initAutoplayVideo);
    document.querySelectorAll('[data-vdps-dwell]').forEach(initDwellReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the theme editor swaps a section in.
  document.addEventListener('shopify:section:load', init);
})();
